// extracted by mini-css-extract-plugin
export default {"stats":"Stats_stats__8YhY+","price":"Stats_price__CeYl7","pricechange":"Stats_pricechange__ipt1N","tbl":"Stats_tbl__GrXhq"};